import type { Category } from '@/apiTypes.ts'
import { VELTHUIS_CAMPAIGN_PREFIX } from '@/utils/common.ts'

export const sortVelthuisCategories = (categories: Category[]): Category[] => {
  // Sort categories with campaign prefix at the top
  return [...categories].sort((categoryA, categoryB) => {
    const isACampaign = categoryA.code.includes(VELTHUIS_CAMPAIGN_PREFIX)
    const isBCampaign = categoryB.code.includes(VELTHUIS_CAMPAIGN_PREFIX)

    // If both are campaign categories, sort them alphabetically
    if (isACampaign && isBCampaign) {
      return categoryA.code.localeCompare(categoryB.code)
    }

    if (isACampaign) return -1
    if (isBCampaign) return 1

    // Sort other categories alphabetically
    return categoryA.code.localeCompare(categoryB.code)
  })
}
